import { FieldValues, Path, UseFormRegister } from 'react-hook-form'
import { AdminGeneralChartFormValues } from '../forms/charts/admin/admin-chart-general-form'
import { AdminNonPartisanChartFormValues } from '../forms/charts/admin/admin-chart-non-partisan-form'
import { AdminPartisanChartFormValues } from '../forms/charts/admin/admin-chart-partisan-form'
import { AdminPresidentialChartFormValues } from '../forms/charts/admin/admin-chart-presidential-form'
import { GeneralChartFormValues } from '../forms/charts/chart-general-form'
import { NonPartisanChartFormValues } from '../forms/charts/chart-non-partisan-form'
import { PartisanChartFormValues } from '../forms/charts/chart-partisan-form'
import { PresidentialChartFormValues } from '../forms/charts/chart-presidential-form'

export type FieldPath<TFieldValues extends FieldValues> = Path<TFieldValues>

export type AnyForm =
  | AdminGeneralChartFormValues
  | AdminNonPartisanChartFormValues
  | AdminPartisanChartFormValues
  | AdminPresidentialChartFormValues
  | GeneralChartFormValues
  | NonPartisanChartFormValues
  | PartisanChartFormValues
  | PresidentialChartFormValues

type AnyFormField = FieldPath<
  | AdminGeneralChartFormValues
  | AdminNonPartisanChartFormValues
  | AdminPartisanChartFormValues
  | AdminPresidentialChartFormValues
  | GeneralChartFormValues
  | NonPartisanChartFormValues
  | PartisanChartFormValues
  | PresidentialChartFormValues
>

interface NumberInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  name: AnyFormField
  defaultValue: number
  register: UseFormRegister<AnyForm>
  className: string
}

export const NumberInput: React.FC<NumberInputProps> = ({
  name,
  register,
  ...props
}) => <input {...register(name)} type="number" {...props} />
